import { toggleModal } from 'actions/appAction';

export const UPDATE_CARDS = 'UPDATE_CARDS';
export const UPDATE_CARDS_LIST = 'UPDATE_CARDS_LIST';
export const RENAME_CARD = 'RENAME_CARD';
export const DELETE_CARD = 'DELETE_CARD';
export const ADDING_SOURCE = 'ADDING_SOURCE';
export const ADD_ACCOUNT_FIELDS = 'ADD_ACCOUNT_FIELDS';
export const ADD_CARD_FIELD = 'ADD_CARD_FIELD';

export const addCardData = (card) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: ADD_CARD_FIELD,
                card: card,
            }),
        );
    };
};
export const addAccountData = (account) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: ADD_ACCOUNT_FIELDS,
                account: account,
            }),
        );
    };
};
export const addingSource = (source, modal, isShowChat = false) => {
    return (dispatch) => {
        dispatch(toggleModal(true, modal));
        return Promise.resolve(
            dispatch({
                type: ADDING_SOURCE,
                source: source,
            }),
        );
    };
};
export const updateCards = (data) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_CARDS,
                data: data,
            }),
        );
    };
};
export const updateCardsList = (cards) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_CARDS_LIST,
                cards: cards,
            }),
        );
    };
};
export const renameCard = (cardId, name) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: RENAME_CARD,
                cardId: cardId,
                name: name,
            }),
        );
    };
};
export const deleteCard = (cardId) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: DELETE_CARD,
                cardId: cardId,
            }),
        );
    };
};
